import script from "./AuthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthPage.vue?vue&type=script&setup=true&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=a187896c&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a187896c"]])

export default __exports__